import React from 'react';
import CloudIcon from '@mui/icons-material/Cloud';
import MapIcon from '@mui/icons-material/Map';
import EmailIcon from '@mui/icons-material/Email';
import ImageIcon from '@mui/icons-material/Image';
import DrawIcon from '@mui/icons-material/Draw';
import FolderIcon from '@mui/icons-material/Folder';
import PhoneIcon from '@mui/icons-material/Phone';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import ApiIcon from '@mui/icons-material/Api';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export const integrationIconMap: Record<string, React.ReactNode> = {
  quickbooks: <AccountBalanceIcon sx={{ fontSize: 28 }} />,
  'google-drive': <FolderIcon sx={{ fontSize: 28 }} />,
  'google-maps': <MapIcon sx={{ fontSize: 28 }} />,
  'google-routes': <MapIcon sx={{ fontSize: 28 }} />,
  twilio: <PhoneIcon sx={{ fontSize: 28 }} />,
  sendgrid: <EmailIcon sx={{ fontSize: 28 }} />,
  cloudinary: <ImageIcon sx={{ fontSize: 28 }} />,
  aws: <CloudIcon sx={{ fontSize: 28 }} />,
  docusign: <DrawIcon sx={{ fontSize: 28 }} />,
  mega: <CloudIcon sx={{ fontSize: 28 }} />,
  oauth: <VpnKeyIcon sx={{ fontSize: 28 }} />,
  api: <ApiIcon sx={{ fontSize: 28 }} />,
};
